import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = { class: "rounded bg-white p-3" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6 col-12" };
const _hoisted_5 = { class: "form-floating mb-3" };
const _hoisted_6 = { class: "form-floating mb-3" };
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = { class: "col-lg-6 col-12" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col-auto" };
const _hoisted_12 = { class: "form-floating mb-3 mb-lg-0" };
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "col-auto" };
const _hoisted_15 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_16 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_17 = { class: "col-auto" };
const _hoisted_18 = { class: "input-group mb-3 mb-lg-0" };
const _hoisted_19 = { class: "form-floating" };
const _hoisted_20 = { class: "input-group-text" };
const _hoisted_21 = { class: "col-auto d-flex align-items-center" };
const _hoisted_22 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_23 = { class: "mb-3" };
const _hoisted_24 = ["onSubmit"];
const _hoisted_25 = { class: "row" };
const _hoisted_26 = { class: "col-auto" };
const _hoisted_27 = { class: "form-floating mb-3 mb-lg-0" };
const _hoisted_28 = ["id", "onUpdate:modelValue"];
const _hoisted_29 = ["value"];
const _hoisted_30 = ["for"];
const _hoisted_31 = { class: "col-auto" };
const _hoisted_32 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_33 = ["id", "onUpdate:modelValue"];
const _hoisted_34 = ["for"];
const _hoisted_35 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_36 = ["id", "onUpdate:modelValue"];
const _hoisted_37 = ["for"];
const _hoisted_38 = { class: "col-auto" };
const _hoisted_39 = { class: "input-group mb-3 mb-lg-0" };
const _hoisted_40 = { class: "form-floating" };
const _hoisted_41 = ["id", "onUpdate:modelValue"];
const _hoisted_42 = ["for"];
const _hoisted_43 = { class: "input-group-text" };
const _hoisted_44 = { class: "col-auto d-flex align-items-center" };
const _hoisted_45 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_46 = ["id", "onUpdate:modelValue"];
const _hoisted_47 = ["for"];
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        supplier: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        const props = __props;
        const confirm = useConfirm();
        const productTypes = [
            { value: 'bottle', label: 'Flasche' },
            { value: 'lid', label: 'Verschluss' },
            { value: 'package', label: 'Verpackung' }
        ];
        const editSupplierForm = useForm({
            name: props.supplier ? props.supplier.name : null,
            address: props.supplier ? props.supplier.address : null,
            contact: props.supplier ? props.supplier.contact : null,
            email: props.supplier ? props.supplier.email : null,
        });
        const createAdditionForm = useForm({
            value: null,
            percentage: false,
            active: true,
            productType: null
        });
        function update() {
            editSupplierForm.transform((data) => ({
                name: data.name,
                address: data.address,
                contact: data.contact,
                email: data.email,
            }))
                .submit('put', route('admin.suppliers.update', props.supplier.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove() {
            confirm.require({
                message: 'Soll der Lieferant wirklich gelöscht werden? Alle Produkt-Verknüpfungen zu diesem Lieferanten werden ebenfalls gelöscht.',
                header: 'Lieferant löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.suppliers.destroy', props.supplier.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function createOrUpdateAddition(addition = null) {
            createAdditionForm.transform((data) => ({
                value: addition ? addition.value : data.value,
                percentage: addition ? addition.percentage : data.percentage,
                active: addition ? addition.active : data.active,
                productType: addition ? addition.productType : data.productType
            }))
                .submit('post', route('admin.suppliers.additions.update', props.supplier.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Lieferant-Details" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Lieferant: " + _toDisplayString(props.supplier.name), 1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("form", {
                                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event) => (update()), ["prevent"]))
                                    }, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editSupplierForm).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editSupplierForm).name]
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "address",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editSupplierForm).address) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editSupplierForm).address]
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "address" }, "Adresse", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "contact",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editSupplierForm).contact) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editSupplierForm).contact]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "contact" }, "Kontakt", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                id: "email",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editSupplierForm).email) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editSupplierForm).email]
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "email" }, "E-Mail", -1))
                                        ]),
                                        _cache[16] || (_cache[16] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32),
                                    _createElementVNode("button", {
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (remove()))
                                    }, [...(_cache[17] || (_cache[17] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Lieferant löschen", -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Aufschläge", -1)),
                                    _createElementVNode("form", {
                                        onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event) => (createOrUpdateAddition()), ["prevent"]))
                                    }, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "newProductTypeSelection",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(createAdditionForm).productType) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productTypes, (type) => {
                                                            return _createElementVNode("option", {
                                                                value: type.value
                                                            }, _toDisplayString(type.label), 9, _hoisted_13);
                                                        }), 64))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(createAdditionForm).productType]
                                                    ]),
                                                    _cache[18] || (_cache[18] = _createElementVNode("label", { for: "newProductTypeSelection" }, "Produkttyp", -1))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", _hoisted_15, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "radio",
                                                        name: "valueType",
                                                        id: "valueTypeFixed",
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(createAdditionForm).percentage) = $event)),
                                                        value: false,
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelRadio, _unref(createAdditionForm).percentage]
                                                    ]),
                                                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: "valueTypeFixed"
                                                    }, "Fester Betrag", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "radio",
                                                        name: "valueType",
                                                        id: "valueTypePercentage",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(createAdditionForm).percentage) = $event)),
                                                        value: true,
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelRadio, _unref(createAdditionForm).percentage]
                                                    ]),
                                                    _cache[20] || (_cache[20] = _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: "valueTypePercentage"
                                                    }, "Prozentualer Betrag", -1))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("div", _hoisted_18, [
                                                    _createElementVNode("div", _hoisted_19, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            id: "newPrice",
                                                            type: "number",
                                                            class: "form-control",
                                                            min: "0",
                                                            step: "0.01",
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(createAdditionForm).value) = $event)),
                                                            required: ""
                                                        }, null, 512), [
                                                            [_vModelText, _unref(createAdditionForm).value]
                                                        ]),
                                                        _cache[21] || (_cache[21] = _createElementVNode("label", { for: "newPrice" }, "Wert", -1))
                                                    ]),
                                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(createAdditionForm).percentage ? '%' : '€'), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        value: true,
                                                        id: "priceAdditionActive",
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(createAdditionForm).active) = $event))
                                                    }, null, 512), [
                                                        [_vModelCheckbox, _unref(createAdditionForm).active]
                                                    ]),
                                                    _cache[22] || (_cache[22] = _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: "priceAdditionActive"
                                                    }, "Aktiv", -1))
                                                ])
                                            ]),
                                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-auto d-flex align-items-center" }, [
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    class: "btn btn-success d-inline-flex align-items-center"
                                                }, [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ]),
                                                    _createElementVNode("span", { class: "ms-2" }, "Anlegen")
                                                ])
                                            ], -1))
                                        ])
                                    ], 32),
                                    _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.supplier.additions, (addition) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("form", {
                                                onSubmit: _withModifiers(($event) => (createOrUpdateAddition(addition)), ["prevent"])
                                            }, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _createElementVNode("div", _hoisted_27, [
                                                            _withDirectives(_createElementVNode("select", {
                                                                class: "form-select",
                                                                id: 'productTypeSelection' + addition.uuid,
                                                                "onUpdate:modelValue": ($event) => ((addition.productType) = $event),
                                                                required: ""
                                                            }, [
                                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productTypes, (productType) => {
                                                                    return _createElementVNode("option", {
                                                                        value: productType.value
                                                                    }, _toDisplayString(productType.label), 9, _hoisted_29);
                                                                }), 64))
                                                            ], 8, _hoisted_28), [
                                                                [_vModelSelect, addition.productType]
                                                            ]),
                                                            _createElementVNode("label", {
                                                                for: 'productTypeSelection' + addition.uuid
                                                            }, "Produkttyp", 8, _hoisted_30)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_31, [
                                                        _createElementVNode("div", _hoisted_32, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                class: "form-check-input",
                                                                type: "radio",
                                                                name: "valueType",
                                                                id: 'valueTypeFixed' + addition.uuid,
                                                                "onUpdate:modelValue": ($event) => ((addition.percentage) = $event),
                                                                value: false,
                                                                required: ""
                                                            }, null, 8, _hoisted_33), [
                                                                [_vModelRadio, addition.percentage]
                                                            ]),
                                                            _createElementVNode("label", {
                                                                class: "form-check-label",
                                                                for: 'valueTypeFixed' + addition.uuid
                                                            }, "Fester Betrag", 8, _hoisted_34)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_35, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                class: "form-check-input",
                                                                type: "radio",
                                                                name: "valueType",
                                                                id: 'valueTypePercentage' + addition.uuid,
                                                                "onUpdate:modelValue": ($event) => ((addition.percentage) = $event),
                                                                value: true,
                                                                required: ""
                                                            }, null, 8, _hoisted_36), [
                                                                [_vModelRadio, addition.percentage]
                                                            ]),
                                                            _createElementVNode("label", {
                                                                class: "form-check-label",
                                                                for: 'valueTypePercentage' + addition.uuid
                                                            }, "Prozentualer Betrag", 8, _hoisted_37)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_38, [
                                                        _createElementVNode("div", _hoisted_39, [
                                                            _createElementVNode("div", _hoisted_40, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    id: 'newPrice' + addition.uuid,
                                                                    type: "number",
                                                                    class: "form-control",
                                                                    min: "0",
                                                                    step: "0.01",
                                                                    "onUpdate:modelValue": ($event) => ((addition.value) = $event),
                                                                    required: ""
                                                                }, null, 8, _hoisted_41), [
                                                                    [_vModelText, addition.value]
                                                                ]),
                                                                _createElementVNode("label", {
                                                                    for: 'newPrice' + addition.uuid
                                                                }, "Wert", 8, _hoisted_42)
                                                            ]),
                                                            _createElementVNode("span", _hoisted_43, _toDisplayString(addition.percentage ? '%' : '€'), 1)
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_44, [
                                                        _createElementVNode("div", _hoisted_45, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                class: "form-check-input",
                                                                type: "checkbox",
                                                                value: true,
                                                                id: 'priceAdditionActive' + addition.uuid,
                                                                "onUpdate:modelValue": ($event) => ((addition.active) = $event)
                                                            }, null, 8, _hoisted_46), [
                                                                [_vModelCheckbox, addition.active]
                                                            ]),
                                                            _createElementVNode("label", {
                                                                class: "form-check-label",
                                                                for: 'priceAdditionActive' + addition.uuid
                                                            }, "Aktiv", 8, _hoisted_47)
                                                        ])
                                                    ]),
                                                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-auto d-flex align-items-center" }, [
                                                        _createElementVNode("button", {
                                                            type: "submit",
                                                            class: "btn btn-success d-inline-flex align-items-center"
                                                        }, [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-check2",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                            ]),
                                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                                        ])
                                                    ], -1))
                                                ])
                                            ], 40, _hoisted_24)
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
